module.exports = __webpack_public_path__ + "static/enterprise-d4f8d619953b832033b9a20da2ffb424.jpg";